/* Image Gallery */
document.querySelectorAll('.gallerySwiper').forEach((swiperEl, index) => {

  // Find navigation buttons *within* the same parent section as the swiper
  const nextBtn = swiperEl.closest('.gallery-wrapper-container')?.querySelector('.button-next-swiper');
  const prevBtn = swiperEl.closest('.gallery-wrapper-container')?.querySelector('.button-prev-swiper');

  // Initialize Swiper for this element only
  new Swiper(swiperEl, {
    rewind: true,
    spaceBetween: 16,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1660: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
    }
  });
});

/* Popular Equipment */
document.querySelectorAll('.equipmentSwiper').forEach((swiperEl, index) => {

  // Find navigation buttons *within* the same parent section as the swiper
  const nextBtn = swiperEl.closest('.equipment-wrapper-container')?.querySelector('.button-next-swiper');
  const prevBtn = swiperEl.closest('.equipment-wrapper-container')?.querySelector('.button-prev-swiper');

  // Initialize Swiper for this element only
  new Swiper(swiperEl, {
    rewind: true,
    spaceBetween: 16,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 16,
      },
      1660: {
        slidesPerView: 5,
        spaceBetween: 16,
      },
    }
  });
});

/* Product Image Gallery */

  var swiper = new Swiper('.thumbsGallerySwiper', {
    direction: 'vertical',
    spaceBetween: 8,
    slidesPerView: 5,
    loop: false,

  });

  var swiper2 = new Swiper('.mainGallerySwiper', {
    rewind: true,
    spaceBetween: 0,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next-gallery',
      prevEl: '.swiper-button-prev-gallery',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    thumbs: {
      swiper: swiper,
    },
  });
  
  // Image change on variant select
function setMainGalleryToVariantImage(sectionId) {
  const mapEl = document.getElementById(`VariantMediaMap-${sectionId}`);
  if (!mapEl) return;

  let variantToMedia = {};
  try { variantToMedia = JSON.parse(mapEl.textContent || "{}"); } catch(e) { return; }

  const sectionEl = document.getElementById(`shopify-section-${sectionId}`);
  if (!sectionEl) return;

  const form = sectionEl.querySelector('form[action*="/cart/add"]');
  const idInput = form?.querySelector('input[name="id"]');
  const variantId = idInput?.value;
  if (!variantId) return;

  const mediaId = variantToMedia[String(variantId)];
  if (!mediaId) return;

  // Use Swiper's own slide list (more reliable than querySelectorAll)
  const slides = Array.from(swiper2.slides);
  const index = slides.findIndex(s => s.getAttribute('data-media-id') == String(mediaId));
  if (index === -1) return;

  swiper2.slideTo(index);

  // Optional thumb sync
  if (swiper) swiper.slideTo(index);
}

// Helper: run AFTER theme finishes updating the hidden variant id
function queueGallerySync(sectionId) {
  // microtask + next frame tends to catch most theme updates
  Promise.resolve().then(() => {
    requestAnimationFrame(() => setMainGalleryToVariantImage(sectionId));
  });
}

// 1) Listen to Dawn-style variant change event (best if available)
document.addEventListener('variant:change', (e) => {
  const sectionId = e.detail?.sectionId || e.target?.closest('[id^="shopify-section-"]')?.id?.replace('shopify-section-','');
  if (sectionId) queueGallerySync(sectionId);
});

// 2) Fallback: listen to changes within variant-selects OR variant-radios OR product form
document.addEventListener('change', (e) => {
  const host =
    e.target.closest('variant-selects') ||
    e.target.closest('variant-radios');

  if (host) {
    const sectionId = host.getAttribute('data-section');
    if (sectionId) return queueGallerySync(sectionId);
  }

  const form = e.target.closest('form[action*="/cart/add"]');
  if (form) {
    const section = form.closest('[id^="shopify-section-"]');
    const sectionId = section?.id?.replace('shopify-section-','');
    if (sectionId) return queueGallerySync(sectionId);
  }
});




/* Product Reviews Swiper */

    var reviewsSwiper = new Swiper(".productReviews", {
      rewind: true,
      spaceBetween: 8,
      navigation: {
        nextEl: ".swiper-button-next.rev",
        prevEl: ".swiper-button-prev.rev",
      },
    });

/* Mini Product Gallery */

        var miniGallery = new Swiper(".minigallery", {
          rewind: true,
            pagination: {
        el: ".swiper-pagination.mg",
      },
      navigation: {
        nextEl: ".swiper-button-next.mg",
        prevEl: ".swiper-button-prev.mg",
      },
    });
